import { render, staticRenderFns } from "./openInquiry.vue?vue&type=template&id=9e46b63a&scoped=true"
import script from "./openInquiry.vue?vue&type=script&lang=js"
export * from "./openInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e46b63a",
  null
  
)

export default component.exports